import { render } from "./CardShimmer.vue?vue&type=template&id=d28a0ad2&scoped=true"
import script from "./CardShimmer.vue?vue&type=script&lang=js"
export * from "./CardShimmer.vue?vue&type=script&lang=js"

import "./CardShimmer.vue?vue&type=style&index=0&id=d28a0ad2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d28a0ad2"

export default script